/**
 * Template types for notifications
 */
const NOTIFICATION_TEMPLATE_TYPE_FIRST = 'first' as const;
const NOTIFICATION_TEMPLATE_TYPE_GRATEFUL = 'grateful' as const;
const NOTIFICATION_TEMPLATE_TYPE_REMINDER = 'reminder' as const;
const NOTIFICATION_TEMPLATE_TYPE_LINK_ONLY = 'linkOnly' as const;

export const NotificationTemplateType = {
  [NOTIFICATION_TEMPLATE_TYPE_FIRST]: NOTIFICATION_TEMPLATE_TYPE_FIRST,
  [NOTIFICATION_TEMPLATE_TYPE_GRATEFUL]: NOTIFICATION_TEMPLATE_TYPE_GRATEFUL,
  [NOTIFICATION_TEMPLATE_TYPE_REMINDER]: NOTIFICATION_TEMPLATE_TYPE_REMINDER,
  [NOTIFICATION_TEMPLATE_TYPE_LINK_ONLY]: NOTIFICATION_TEMPLATE_TYPE_LINK_ONLY,
};

export type NotificationTemplateType = keyof typeof NotificationTemplateType;

/**
 * Channels and types for notifications
 */
enum Channel {
  email = 'email',
  whatsApp = 'whatsApp',
}

/**
 * Types for notifications
 */
type Notification = {
  templateType: NotificationTemplateType;
  templateVariation: number;
  content: string;
};

export { Channel };
export type { Notification };
